<script>
// 本地测试地址 开发环境
const target = 'https://xmwzd.xmorigin.com/' // 测试地址 开发环境
const developUrl = '/cms/handler/' // 地址后缀  开发环境 https://xmwzd.xmorigin.com/api/handler/
 // 打包环境
const buildUrl = 'https://xmwzd.xmorigin.com/cms/handler/' // 打包环境

// 全局配置
const proName = '新民市跨境进出口供应链平台' // 项目名称
const proNameEn='Xinmin City Cross-border Import and Export Supply Chain Platform'; // 英文项目名称

// 图片上传全局配置
const proNameFile = 'bayuquan' // 项目文件名
const imgType = 0 // 上传类型 0=阿里云OSS 1=腾讯云OSS 2=华为云OBS
const imgStatus = false // 是否支持远程 密钥  true=是 false=否
// OBS 图片上传
// const bucketName = 'shequ-e574' // 桶名
// const ImgUrl = 'https://shequ-e574.obs.cn-north-4.myhuaweicloud.com/' // 图片地址前缀
// const accessKeyId = 'GWOFE3NIRVH98OSSHETV' // keyId
// const secretAccessKey = '0ufL4mfuOaymgVYlRqI9dq5sTB9BwJUfxrdzEX2p' // 密钥
// const regionName = '' // 桶的所在地区  华为OBS没用到
// const serverUrl = 'https://obs.cn-north-4.myhuaweicloud.com' // 上传地址

// OSS 阿里云
const bucketName = 'lpgcms' // 桶名
const ImgUrl = 'http://cdn.lamifeng.net/' // 图片地址前缀
const accessKeyId = 'LTAI4GL3ZZKwgZ8XJR6tvjcg' // keyId
const secretAccessKey = '30WJYhXdb429Yaql82YNZxdzlFbBSJ' // 密钥
const regionName = 'oss-cn-beijing' // 桶的所在地区

// COS 腾讯云
// const bucketName = 'houzeng-1301111980'
// const ImgUrl = 'https://houzeng-1301111980.cos.ap-beijing.myqcloud.com/' // 图片地址前缀
// const accessKeyId = 'AKIDnRuBF72kGajifNs88sNefQwGKAl6D6lC' // 密钥id
// const secretAccessKey = 'IJ6icLr9E7nHZfW9YhaCaqujJekHitnR' // 密钥的key
// const regionName = 'ap-beijing' // 桶的所在地区

  export default
  {
    proName, // 项目名称
    proNameEn,// 英文项目名称
    buildUrl,  // 打包环境
    developUrl, // 地址后缀  开发环境
    target, // 测试地址
    imgType, // 上传类型 0=阿里云OSS 1=腾讯云OSS 2=华为云OBS
    imgStatus, // 是否支持远程 密钥  true=是 false=否
    proNameFile, // 项目文件名
    bucketName, // 桶名 阿里云 腾讯云
    regionName, // 桶的所在地区
    ImgUrl, // 图片地址前缀
    // serverUrl, // 图片地址前缀 华为云
    accessKeyId, // 密钥id
    secretAccessKey // 密钥的key
  }
</script>


// WEBPACK FOOTER //
// src/components/Global.vue